/**
 * Generated by orval 🍺
 * Do not edit manually.
 * standard public schema
 * OpenAPI spec version: 16.1
 */
import type {
  DeleteMaintenanceBrakeTestsParams,
  GetMaintenanceBrakeTestsParams,
  MaintenanceBrakeTests,
  MaintenanceBrakeTestsInsertPayload,
  MaintenanceBrakeTestsUpdate,
  PatchMaintenanceBrakeTestsParams,
  PostMaintenanceBrakeTestsParams,
  PostgrestError
} from '../../models';

import {
  backendBaseUrl
} from '@/api/vtnz-backend/baseUrl';


export type HTTPStatusCode1xx = 100 | 101 | 102 | 103;
export type HTTPStatusCode2xx = 200 | 201 | 202 | 203 | 204 | 205 | 206 | 207;
export type HTTPStatusCode3xx = 300 | 301 | 302 | 303 | 304 | 305 | 307 | 308;
export type HTTPStatusCode4xx = 400 | 401 | 402 | 403 | 404 | 405 | 406 | 407 | 408 | 409 | 410 | 411 | 412 | 413 | 414 | 415 | 416 | 417 | 418 | 419 | 420 | 421 | 422 | 423 | 424 | 426 | 428 | 429 | 431 | 451;
export type HTTPStatusCode5xx = 500 | 501 | 502 | 503 | 504 | 505 | 507 | 511;
export type HTTPStatusCodes = HTTPStatusCode1xx | HTTPStatusCode2xx | HTTPStatusCode3xx | HTTPStatusCode4xx | HTTPStatusCode5xx;

export type getMaintenanceBrakeTestsResponse200 = {
  data: MaintenanceBrakeTests[]
  status: 200
}

export type getMaintenanceBrakeTestsResponse206 = {
  data: MaintenanceBrakeTests[]
  status: 206
}

export type getMaintenanceBrakeTestsResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 200 | 206>
}

export type getMaintenanceBrakeTestsResponseSuccess = (getMaintenanceBrakeTestsResponse200 | getMaintenanceBrakeTestsResponse206) & {
  headers: Headers;
};
export type getMaintenanceBrakeTestsResponseError = (getMaintenanceBrakeTestsResponseDefault) & {
  headers: Headers;
};

export type getMaintenanceBrakeTestsResponse = (getMaintenanceBrakeTestsResponseSuccess | getMaintenanceBrakeTestsResponseError)

export const getGetMaintenanceBrakeTestsUrl = (params?: GetMaintenanceBrakeTestsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/maintenance_brake_tests?${stringifiedParams}` : `${backendBaseUrl}/maintenance_brake_tests`
}

/**
 * @summary Read rows from `maintenance_brake_tests`.
 */
export const getMaintenanceBrakeTests = async (params?: GetMaintenanceBrakeTestsParams, options?: RequestInit): Promise<getMaintenanceBrakeTestsResponse> => {

  const res = await fetch(getGetMaintenanceBrakeTestsUrl(params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getMaintenanceBrakeTestsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getMaintenanceBrakeTestsResponse
}


export type postMaintenanceBrakeTestsResponse201 = {
  data: MaintenanceBrakeTests[]
  status: 201
}

export type postMaintenanceBrakeTestsResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 201>
}

export type postMaintenanceBrakeTestsResponseSuccess = (postMaintenanceBrakeTestsResponse201) & {
  headers: Headers;
};
export type postMaintenanceBrakeTestsResponseError = (postMaintenanceBrakeTestsResponseDefault) & {
  headers: Headers;
};

export type postMaintenanceBrakeTestsResponse = (postMaintenanceBrakeTestsResponseSuccess | postMaintenanceBrakeTestsResponseError)

export const getPostMaintenanceBrakeTestsUrl = (params?: PostMaintenanceBrakeTestsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/maintenance_brake_tests?${stringifiedParams}` : `${backendBaseUrl}/maintenance_brake_tests`
}

/**
 * @summary Insert one or more rows into `maintenance_brake_tests`.
 */
export const postMaintenanceBrakeTests = async (maintenanceBrakeTestsInsertPayload: MaintenanceBrakeTestsInsertPayload,
    params?: PostMaintenanceBrakeTestsParams, options?: RequestInit): Promise<postMaintenanceBrakeTestsResponse> => {

  const res = await fetch(getPostMaintenanceBrakeTestsUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(maintenanceBrakeTestsInsertPayload)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: postMaintenanceBrakeTestsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as postMaintenanceBrakeTestsResponse
}


export type patchMaintenanceBrakeTestsResponse200 = {
  data: MaintenanceBrakeTests[]
  status: 200
}

export type patchMaintenanceBrakeTestsResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 200>
}

export type patchMaintenanceBrakeTestsResponseSuccess = (patchMaintenanceBrakeTestsResponse200) & {
  headers: Headers;
};
export type patchMaintenanceBrakeTestsResponseError = (patchMaintenanceBrakeTestsResponseDefault) & {
  headers: Headers;
};

export type patchMaintenanceBrakeTestsResponse = (patchMaintenanceBrakeTestsResponseSuccess | patchMaintenanceBrakeTestsResponseError)

export const getPatchMaintenanceBrakeTestsUrl = (params?: PatchMaintenanceBrakeTestsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/maintenance_brake_tests?${stringifiedParams}` : `${backendBaseUrl}/maintenance_brake_tests`
}

/**
 * @summary Update the rows of `maintenance_brake_tests` matching the given filters.
 */
export const patchMaintenanceBrakeTests = async (maintenanceBrakeTestsUpdate: MaintenanceBrakeTestsUpdate,
    params?: PatchMaintenanceBrakeTestsParams, options?: RequestInit): Promise<patchMaintenanceBrakeTestsResponse> => {

  const res = await fetch(getPatchMaintenanceBrakeTestsUrl(params),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(maintenanceBrakeTestsUpdate)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: patchMaintenanceBrakeTestsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as patchMaintenanceBrakeTestsResponse
}


export type deleteMaintenanceBrakeTestsResponse200 = {
  data: MaintenanceBrakeTests[]
  status: 200
}

export type deleteMaintenanceBrakeTestsResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 200>
}

export type deleteMaintenanceBrakeTestsResponseSuccess = (deleteMaintenanceBrakeTestsResponse200) & {
  headers: Headers;
};
export type deleteMaintenanceBrakeTestsResponseError = (deleteMaintenanceBrakeTestsResponseDefault) & {
  headers: Headers;
};

export type deleteMaintenanceBrakeTestsResponse = (deleteMaintenanceBrakeTestsResponseSuccess | deleteMaintenanceBrakeTestsResponseError)

export const getDeleteMaintenanceBrakeTestsUrl = (params?: DeleteMaintenanceBrakeTestsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/maintenance_brake_tests?${stringifiedParams}` : `${backendBaseUrl}/maintenance_brake_tests`
}

/**
 * @summary Delete the rows of `maintenance_brake_tests` matching the given filters.
 */
export const deleteMaintenanceBrakeTests = async (params?: DeleteMaintenanceBrakeTestsParams, options?: RequestInit): Promise<deleteMaintenanceBrakeTestsResponse> => {

  const res = await fetch(getDeleteMaintenanceBrakeTestsUrl(params),
  {
    ...options,
    method: 'DELETE'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: deleteMaintenanceBrakeTestsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as deleteMaintenanceBrakeTestsResponse
}


